import _, {
  endsWith, extend, forEach, template,
} from 'lodash';
import { t } from '@/libs/i18n';
import ApplicationController from './application_controller';
import { conectarSubmenus } from '../../../libs/bootstrap';

/* global Mn, $, Cifra */
const NAMESPACE_CSS = '.cifra-se';

const TEMPLATE = template(`
<div class="input-group estructura-selector <%= disabled ? 'disabled' : '' %>">
  <div class="input-group-btn">
    <button type="button" class="btn btn-cifra dropdown-toggle <%= disabled ? 'disabled' : '' %>" data-toggle="dropdown">
      <% if (loading){ %>
        ${t('cargando')}...
      <% }else{ %>
        <% if (!disabled){ %>
          <% if (small){ %>
            ${t('Curso')}
          <%  } else { %>
            <span class="hidden-sm hidden-xs">${t('seleccione_curso')}</span>
            <span class="hidden-md hidden-lg">${t('Curso')}</span>
          <% } %>
          <span class="caret"></span>
        <% } else { %>
          ${t('Curso')}
        <% } %>
      <% } %>
    </button>
    <ul class="dropdown-menu">
      <% _(annos_lectivos).forEach(function(an){ %>
        <li class="menu-item dropdown dropdown-submenu">
          <a data-id="<%= an.id %>" data-type="anno_lectivo"
            data-toggle="dropdown" data-propagation="false" aria-haspopup="true" aria-expanded="false">
            <%= an.nombre %>
          </a>
          <ul class="dropdown-menu" aria-labelledby="dLabel">
            <% _(an.ensennanzas).forEach(function(en){ %>
              <%
              var otrosGruposEnsenannza = !_.isEmpty(en.grupos);

              if (!_.isEmpty(allowedTiposEnsennanza) && !_.includes(allowedTiposEnsennanza, en.tipo)){
                return;
              }
              %>
              <li class="menu-item dropdown dropdown-submenu">
                <a data-id="<%= en.id %>" data-type="ensennanza"
                  data-toggle="dropdown" data-propagation="false" aria-haspopup="true" aria-expanded="false">
                  <%= en.abbr %>
                </a>
                <ul class="dropdown-menu" aria-labelledby="dLabel">
                  <% _(en.niveles).forEach(function(niv){ %>
                    <% _(niv.cursos).forEach(function(c){
                      var hasChildren = false;
                      hasChildren = mostrarGrupos && (!_.isEmpty(c.grupos) || !_.isEmpty(_.flatten(_.map(c.modalidades, 'grupos'))));
                      hasChildren = hasChildren || (mostrarModalidades && !_.isEmpty(c.modalidades));
                      %>
                      <li class="menu-item dropdown <%= hasChildren ? 'dropdown-submenu' : '' %>">
                        <a data-id="<%= c.id %>" data-type="curso"
                          <% if (hasChildren){ %>
                            data-toggle="dropdown" data-propagation="false" aria-haspopup="true" aria-expanded="false"
                          <% } else { %>
                            data-closeable="true"
                          <% } %>
                          >
                          <%= niv.abbr %> <%= c.nombre %>
                        </a>
                        <% if (hasChildren){ %>
                          <ul class="dropdown-menu" aria-labelledby="dLabel">
                            <% if (mostrarGrupos){ %>
                              <% _(c.grupos).forEach(function(g){ %>
                                <li class="menu-item">
                                  <a data-id="<%= g.id %>" data-type="grupo">
                                    <%= g.etiqueta %>
                                  </a>
                                </li>
                              <% }); %>
                            <% } %>
                            <% _(c.modalidades).forEach(function(m){ %>
                              <% if (mostrarModalidades){ %>
                                <li class="menu-item">
                                  <a data-id="<%= m.id %>" data-type="modalidad"
                                    <% if (mostrarGrupos){ %>
                                      data-toggle="dropdown" data-propagation="false" aria-haspopup="true" aria-expanded="false"
                                    <% } %>
                                  >
                                    <%= m.nombre %>
                                  </a>
                                  <ul class="dropdown-menu" aria-labelledby="dLabel">
                              <% } %>
                              <% _(m.grupos).forEach(function(g){ %>
                                <li class="menu-item">
                                  <a data-id="<%= g.id %>" data-type="grupo">
                                    <%= g.etiqueta %>
                                  </a>
                                </li>
                              <% }); %>
                              <% if (mostrarModalidades){ %>
                                  </ul>
                                </li>
                              <% } %>
                            <% }); %>
                          </ul>
                        <% } %>
                      </li>
                    <% }); %>
                  <% }); %>
                  <% if (mostrarGrupos && otrosGruposEnsenannza) { %>
                  <li class="menu-item dropdown dropdown-submenu">
                    <a data-id="<%= en.id %>"
                       data-type="grupos"
                       data-toggle="dropdown"
                       data-propagation="false"
                       aria-haspopup="true" aria-expanded="false">
                      <%= I18n.t('Otros_grupos') %>
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="dLabel">
                    <% _(en.grupos).forEach(function(g){ %>
                      <li class="menu-item">
                        <a data-id="<%= g.id %>" data-type="grupo">
                          <%= g.etiqueta %>
                        </a>
                      </li>
                    <% }); %>
                    </ul>
                  </li>
                  <% } %>
                </ul>
              </li>
            <% }); %>
          </ul>
        </li>
      <% }); %>
    </ul>
  </div>
  <p class="form-control cifra-se-input-label"></p>
  <% _.each(allowedTypes, function(type){ %>
    <input type="hidden" class="cifra-se-input <%= type %>"
      <% if (fieldContext){ %>
        name='<%= fieldContext %>[<%= type %>_id]' />
      <% } else { %>
        name='<%= type %>_id' />
      <% } %>
  <% }); %>
  <span class="input-group-btn">
    <button class="btn btn-default cifra-se-clear <%= disabled ? 'disabled' : '' %>" type="button">
      <i class="fa fa-eraser"></i>
    </button>
  </span>
</div>
`);
/*
* Plugin para gestionar el input de selección de curso o grupo para usarlo en
* formularios de filtros o altas etc.
* Este plugin gestiona por javascript el cambio de año y muestra el selector de
* curso/grupo.
*
* initialValues: Se debe de pasar un objeto del estilo:
  initialValues: {
    anno_lectivo: 12,
    ensennanza: 23,
    curso: 54
  }
* Se pasará con un valor o con N, dependiendo de la configuración
*/
Cifra.Components.SelectorEstructura = Mn.View.extend({
  template: TEMPLATE,
  ui: {
    label: `${NAMESPACE_CSS}-input-label`,
    cleaner: `${NAMESPACE_CSS}-clear`,
  },
  events: {
    'click @ui.cleaner': 'clear',
    'click .menu-item > a': 'menuClicked',
  },
  modelEvents: {
    // eslint-disable-next-line quote-props
    'sync': 'render',
  },
  allowedTypes: ['anno_lectivo', 'ensennanza', 'curso', 'grupo'],
  initialize(options) {
    this.mergeOptions(options, ['fieldContext', 'allowedTypes', 'allowedTiposEnsennanza', 'disabled']);
    if (this.allowedTypes && _.isString(this.allowedTypes)) {
      this.allowedTypes = this.allowedTypes.split(' ');
    }
    if (this.allowedTiposEnsennanza && _.isString(this.allowedTiposEnsennanza)) {
      this.allowedTiposEnsennanza = this.allowedTiposEnsennanza.split(' ');
    }
    this.selected = {};
    if (this.getOption('estructura')) {
      this.model = new Cifra.Models.EstructuraEscolar(this.getOption('estructura'));
    }
    if (!this.model) {
      this.model = new Cifra.Models.EstructuraEscolar({});
    }
    this.initialValues = this.getOption('initialValues') || this.$el.data('initial-values');
  },
  templateContext() {
    return {
      fieldContext: this.fieldContext,
      allowedTypes: this.allowedTypes,
      allowedTiposEnsennanza: this.allowedTiposEnsennanza,
      disabled: this.disabled === true,
      loading: this.loading,
      small: this.small,
      mostrarGrupos: _.includes(this.allowedTypes, 'grupo'),
      mostrarModalidades: _.includes(this.allowedTypes, 'modalidad'),
    };
  },
  /*
  Carga la estructura escolar y renderiza.
  Devuelve el promise de la llamada ajax
  */
  loadAndRender(options) {
    this._renderLoading();
    return this.model.fetch(options);
  },
  // Indica si es la carga inicial del componente
  isInitialLoading() {
    return this.initialValues !== undefined;
  },
  onRender() {
    const self = this;
    this.small = this.$el.hasClass('selector-sm');
    if (this.loading) {
      return;
    }
    if (this.initialValues) {
      forEach(this.initialValues, (value, key) => {
        if (endsWith(key, '_id')) {
          // eslint-disable-next-line no-param-reassign
          key = key.substring(0, key.length - 3);
        }
        self.selectOption(key, value);
      });
    }
    this.initialValues = undefined;
    conectarSubmenus(this.$el);
    this.$el.css('z-index', '999');
  },
  clear() {
    if (this.disabled) {
      return;
    }

    this.$(`${NAMESPACE_CSS}-input`).val('');
    this.selected = {};
    this.getUI('label').text('');
    this.triggerMethod('clear');
    if (this.getOption('submitOnChange')) {
      this.$el.closest('form').submit();
    } else if (this.getOption('requestSubmitOnChange')) {
      // Para que lo cace Turbo llamamos a requestSubmit en vez de submit
      this.$el.closest('form')[0].requestSubmit();
    }
  },
  getSelectedValue() {
    return this.selected.id;
  },
  getSelectedPath() {
    if (_.isEmpty(this.selected)) {
      return [];
    }
    return this.model.findByTypeWithPath(this.selected.type, this.selected.id);
  },
  getSelectedPathHash() {
    return _(this.getSelectedPath()).groupBy('type').mapValues(_.first).value();
  },
  tieneSeleccion() {
    return !_.isEmpty(this.selected);
  },
  menuClicked(e) {
    e.preventDefault();
    e.stopPropagation();
    const $link = $(e.currentTarget);
    this.selectOption($link.data('type'), $link.data('id'), $link.data('closeable'));
  },
  selectOption(type, selectedId, closeOnSelect) {
    if (!_.includes(this.allowedTypes, type)) {
      return this;
    }
    const path = this.model.findByTypeWithPath(type, selectedId);
    this.setFieldValue(type, selectedId, path);
    this.ui.label.html(this._renderPathLabels(path));
    this.triggerMethod('option:selected', type, selectedId, path);
    // Si es el último nivel o no tiene hijos, ocultamos
    if (closeOnSelect || (type === _.last(this.allowedTypes))) {
      this.$('.in, .open').removeClass('in open');
    }
    // Si hay valores iniciales signifca que está asignándolo, no notificamos
    if (!this.initialValues) {
      if (this.getOption('submitOnChange')) {
        this.$el.closest('form').submit();
      } else if (this.getOption('requestSubmitOnChange')) {
        // Para que lo cace Turbo llamamos a requestSubmit en vez de submit
        this.$el.closest('form')[0].requestSubmit();
      }
    }

    return this;
  },
  setFieldValue(type, selectedId, path) {
    const self = this;
    this.selected = {
      type,
      id: selectedId,
    };
    // Ponemos valores de campos anteriores (si seleccionan curso y está ensennanza,
    // hay que poner también id a la enseñanza)
    _.each(path, (nivel) => {
      if (_.includes(self.allowedTypes, type)) {
        self._getInputByType(nivel.type).val(nivel.id);
      }
    });
    // Limpiamos campos siguientes
    const allowedTypes = this.allowedTypes.slice(_.indexOf(this.allowedTypes, type) + 1);
    _.each(allowedTypes, (t) => {
      self._getInputByType(t).val('');
    });
  },
  _renderLoading() {
    this.loading = true;
    this.render();
    this.loading = false;
  },
  _renderPathLabels(path) {
    const self = this;
    let label = '';
    if (path && path.length) {
      let previousVal;
      _(path).forEach((p) => {
        const val = p.etiqueta || p.abbr || p.nombre;
        // Si hay dos etiquetas seguidas que tienen el mismo nombre, sólo mostramos una
        if (val !== previousVal) {
          const margen = self.small ? 'm-r-xs' : 'm-r-sm';
          label += `<span class="label label-default ${margen}">${val}</span>`;
          previousVal = val;
        }
      });
    }
    return label;
  },
  _getInputByType(type) {
    return this.$(`${NAMESPACE_CSS}-input.${type}`);
  },
});

export default class extends ApplicationController {
  connect() {
    const options = extend({
      el: this.element,
    }, $(this.element).data());

    this.component = new Cifra.Components.SelectorEstructura(options);
    const loadData = {
      current: options.onlyCurrentYear === true,
      only_academic_groups: options.onlyAcademicGroups === true,
      incluir_extraescolares: options.incluirExtraescolares === true,
      solo_cursos_lomloe: options.soloCursosLomloe === true,
      anno_lectivo_id: options.annoLectivo || '',
      check_perms: options.checkPerms !== undefined ? options.checkPerms : '',
      add_grupos_profesor: options.addGruposProfesor !== false,
      add_grupos_hijos: options.addGruposHijos === true,
    };
    this.component.loadAndRender({
      overlay: false,
      data: loadData,
    });
    this.lanzarEventoCargado();
    this.#relanzarEventosVanillaJs();
  }

  // Lanzamos los eventos como eventos normales para poder conectarnos
  // desde otro javascript sin hacer cosas raras
  #relanzarEventosVanillaJs() {
    this.component.on('option:selected clear', () => {
      const evento = new CustomEvent('change', {
        detail: {
          controller: this,
          selectedPath: this.component.getSelectedPath(),
        },
      });
      this.element.dispatchEvent(evento);
    });
  }
}
